export function EndChapter() {
  return (
    <div className='flex items-center gap-x-[10px] m-auto max-w-[700px] text-[18px] font-[500] pt-[50px] text-secondary'>
      <div className='border-t-[1px] border-gray h-[1px] flex-1' />
      จบตอน
      <div className='border-t-[1px] border-gray h-[1px] flex-1' />
    </div>
  )
}
